import { buildMakeUseAxios } from "@api";
import type { IAddress, TAddressQPV } from "@bbj-types/address";
import { useCallback } from "react";

const axiosV2 = buildMakeUseAxios(`${import.meta.env.VITE_TRANSPORT_SERVICE_URL}/v2`);

export const useGetAddressV2 = <CalculateQPV extends boolean>(calculateQpv: CalculateQPV) => {
  const [state, execute, cancel] = axiosV2<CalculateQPV extends true ? TAddressQPV[] : IAddress[]>(
    {
      url: "/addresses",
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (query: string, type?: string, disableGoogle?: boolean) => {
      return execute({
        url: "/addresses",
        params: { q: query, type, disableGoogle, calculateQpv },
      });
    },
    [execute, calculateQpv]
  );

  return [state, callback, cancel] as const;
};
